import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useEffect, useRef, useState } from 'react';
export var useAddressInput = function useAddressInput(_ref) {
  var isMobile = _ref.isMobile,
    onSelect = _ref.onSelect,
    isError = _ref.isError,
    errorText = _ref.errorText,
    handleErrorStatus = _ref.handleErrorStatus,
    initValue = _ref.initValue,
    onFocus = _ref.onFocus,
    handleViewErrorStatusAnalytics = _ref.handleViewErrorStatusAnalytics;
  var _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    addressInputValue = _useState2[0],
    setAddressInputValue = _useState2[1];
  var _useState3 = useState(''),
    _useState4 = _slicedToArray(_useState3, 2),
    errorMessage = _useState4[0],
    setErrorMessage = _useState4[1];
  var inputRef = useRef(null);
  useEffect(function () {
    if (inputRef.current) {
      inputRef.current.scrollLeft = inputRef.current.scrollWidth;
    }
  }, [addressInputValue]);
  useEffect(function () {
    setAddressInputValue(initValue || '');
  }, [initValue]);
  useEffect(function () {
    if (inputRef.current && isError) {
      setErrorMessage(errorText || '');
      handleViewErrorStatusAnalytics === null || handleViewErrorStatusAnalytics === void 0 || handleViewErrorStatusAnalytics(addressInputValue);
    }
  }, [isError]);
  var handleChange = function handleChange(text) {
    setAddressInputValue(text);
  };
  var handleSelect = function handleSelect(option) {
    setAddressInputValue(option.value);
    onSelect === null || onSelect === void 0 || onSelect(option);
  };
  var onScrollRight = function onScrollRight() {
    var current = inputRef.current;
    if (current) {
      current.scrollLeft = current.scrollWidth;
    }
  };
  var onClickMobile = function onClickMobile() {
    if (isMobile) {
      var _inputRef$current;
      (_inputRef$current = inputRef.current) === null || _inputRef$current === void 0 || _inputRef$current.setSelectionRange(addressInputValue.length, addressInputValue.length);
    }
  };
  var handleFocus = function handleFocus() {
    onFocus === null || onFocus === void 0 || onFocus();
    if (addressInputValue.length) {
      handleErrorStatus === null || handleErrorStatus === void 0 || handleErrorStatus(false);
      setErrorMessage('');
    }
    onScrollRight();
  };
  return {
    inputRef: inputRef,
    handleChange: handleChange,
    handleSelect: handleSelect,
    handleFocus: handleFocus,
    addressInputValue: addressInputValue,
    errorMessage: errorMessage,
    onScrollRight: onScrollRight,
    onClickMobile: onClickMobile
  };
};